var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFileCircleCheck = function SvgFileCircleCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-circle-check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.332 23V8L41.332 23H26.332ZM59.332 42.5C59.332 49.9531 53.2852 56 45.832 56C38.3789 56 32.332 49.9531 32.332 42.5C32.332 35.0469 38.3789 29 45.832 29C53.2852 29 59.332 35.0469 59.332 42.5ZM50.0227 38.4406L44.332 44.1312L41.6414 41.4406C41.0602 40.85 40.1039 40.85 39.5227 41.4406C38.932 42.0219 38.932 42.9781 39.5227 43.5594L43.2727 47.3094C43.8539 47.9 44.8102 47.9 45.3914 47.3094L52.1414 40.5594C52.732 39.9781 52.732 39.0219 52.1414 38.4406C51.5602 37.85 50.6039 37.85 50.0227 38.4406Z",
    fill: "#FF7342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.4,
    d: "M5.33203 14C5.33203 10.6859 8.01797 8 11.332 8H26.332V23H41.332V26.6188C34.4039 28.5781 29.332 34.9438 29.332 42.5C29.332 48.0406 32.0602 52.9344 36.2414 55.9344C35.9508 55.9719 35.6414 56 35.332 56H11.332C8.01797 56 5.33203 53.3094 5.33203 50V14Z",
    fill: "#FF7342"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFileCircleCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/file-circle-check.7d55fbf0.svg";
export { ForwardRef as ReactComponent };